import React from 'react';
import { handleView } from '../handle_view';
import { FriendbuyLightBoxStore } from '../../_flux/stores/friendbuy_light_box';
import { LightBox } from '../../_flux/components/friendbuy_light_box/light_box';
import { hide } from '../../_flux/actions/friendbuy_light_box_actions';

const stores = {
    lightBox: FriendbuyLightBoxStore,
};

const render = ({ lightBox }, options) => (
    <LightBox
        visible={lightBox.visible}
        onClose={hide}
        staticUrl={TYROOLA.globals.staticImagesUrl}
        baseUrl={options.baseUrl}
        storeUrl={options.storeUrl}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
